var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-container"},[(_vm.lastStatusColor)?_c('div',{staticClass:"bar",style:(("background-color: " + _vm.lastStatusColor + ";"))}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }